import { useContext } from 'react';
import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap';
import { BILL_MANAGEMENT_CONST } from '../../constant';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import LoaderResoinse from '../../loader/loader';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import { MenuItem } from '@mui/material';
import {  Trash } from 'react-feather';

const PaymentList = (props) => {
  const { close, deleteHandle } = props;

  const { paymentListModal, paymentListValue } = useContext(BillManagementContext);
  const { loaderShow } = useContext(OrganizationContext);

  return (
    <Modal size="xl" isOpen={paymentListModal} toggle={close}>
      {loaderShow && <LoaderResoinse />}

      <ModalHeader toggle={close}>
        <span>{BILL_MANAGEMENT_CONST.PAYMENT_LIST}</span>
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table bordered hover responsive>
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Payment Date</th>
                        <th>Amount</th>
                        <th>Payment Mode</th>
                        <th>Reference No</th>
                        <th>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {paymentListValue?.length > 0 ? (
                        paymentListValue.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.paymentDate}</td>
                            <td>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(item.amount)}</td>
                            <td>{item.paymentMode}</td>
                            <td>{item.referenceNo || '-'}</td>
                            <td>{item.remark || '-'}</td>
                            <td>
                              <MenuItem onClick={() => deleteHandle(item.id)}>
                                <Trash style={{ color: 'red' }} />
                              </MenuItem>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No payments found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default PaymentList;
